import * as React from 'react';
import { Helmet } from 'react-helmet';

export type HreflangItem = {
  langCode: string;
  url: string;
}

interface HreflangTagsProps {
  locale: string;
  canonicalUrl: string;
  alternateUrls: HreflangItem[];
}

export const HreflangTags: React.FunctionComponent<HreflangTagsProps> = ({ locale, canonicalUrl, alternateUrls }) => {
  if (!alternateUrls.length) return null;
  const linkTags = alternateUrls.map((item: HreflangItem, index) => <link key={index} rel="alternate" hrefLang={item.langCode} href={item.url} />);
  return (
    <Helmet>
      <link rel="alternate" hrefLang={locale} href={canonicalUrl} />
      {linkTags}
    </Helmet>
  );
};
